import React from 'react';

interface ToggleButtonProps {
  activeValue: string;
  options: Array<{
    value: string;
    label: string;
  }>;
  onChange: (value: string) => void;
  className?: string;
}

const ToggleButton: React.FC<ToggleButtonProps> = ({
  activeValue,
  options,
  onChange,
  className = ''
}) => {
  return (
    <div className={`flex gap-2 ${className}`}>
      {options.map((option) => (
        <button
          key={option.value}
          className={`px-4 py-2 rounded-lg font-medium transition-all duration-base ${
            activeValue === option.value
              ? 'bg-primary-600 text-theme-inverse shadow-md'
              : 'bg-theme-secondary text-theme-secondary hover:bg-theme-tertiary hover:text-theme-primary'
          }`}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default ToggleButton;